import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { IpAddress } from "../Core/IpAddress";
import { TimeSpan } from "../Utils/TimeSpan";
import { ValueEncoder } from "../Utils/ValueEncoder";
import { DiscoverySubtaskHandle } from "./DiscoverySubtaskHandle";
import { List } from "DiscoveryEngine.TS/Utils/List";

export class CollectorChainEntry implements ObjectSerializer {

    public CollectorType: string;
    public InfoSetName: string;
    public StartTime: Date;
    public RunTime: TimeSpan;

    constructor() {
        this.Clear();
    }

    public Clear(): void {
        this.CollectorType = "";
        this.InfoSetName = "";
        this.StartTime = null;
        this.RunTime = null;
    }

    public get HasStartTime(): boolean {
        return (this.StartTime != null);
    }

    public get HasRunTime(): boolean {
        return (this.RunTime != null);
    }

    public Write(obj: any, context: any): void {
        obj.collector_chain_entry = {};
        obj = obj.collector_chain_entry;

        obj.collector_type = this.CollectorType;
        obj.info_set_name = this.InfoSetName;

        if (this.HasStartTime)
            obj.start_time = ValueEncoder.EncodeDateTime(this.StartTime);

        if (this.HasRunTime)
            obj.run_time = ValueEncoder.EncodeTimeSpan(this.RunTime);
    }

    public Read(obj: any, context: any): void {
        this.Clear();

        if (!obj.collector_chain_entry) {
            throw new Error();
        }
        obj = obj.collector_chain_entry;

        if (obj.collector_type !== undefined)
            this.CollectorType = obj.collector_type;

        if (obj.info_set_name !== undefined)
            this.InfoSetName = obj.info_set_name;

        if (obj.start_time !== undefined)
            this.StartTime = ValueEncoder.DecodeDateTime(obj.start_time);

        if (obj.run_time !== undefined)
            this.RunTime = ValueEncoder.DecodeTimeSpan(obj.run_time);
    }

}


export class DiscoverySubtaskStatus implements ObjectSerializer {

    public SubtaskHandle: DiscoverySubtaskHandle;
    public TaskType: string;
    public IpAddress: IpAddress;
    public StartTime: Date;
    public RunTime: TimeSpan;
    public CollectorChain: List<CollectorChainEntry>;

    constructor() {
        this.Clear();
    }

    public Clear(): void {
        this.SubtaskHandle = null;
        this.TaskType = "";
        this.IpAddress = null;
        this.StartTime = null;
        this.RunTime = null;
        this.CollectorChain = new List<CollectorChainEntry>();
    }

    public get HasSubtaskHandle(): boolean {
        return (this.SubtaskHandle != null);
    }

    public get HasTaskType(): boolean {
        return !!this.TaskType;
    }

    public get HasIpAddress(): boolean {
        return (this.IpAddress != null);
    }

    public get HasStartTime(): boolean {
        return (this.StartTime != null);
    }

    public get HasRunTime(): boolean {
        return (this.RunTime != null);
    }

    public get HasCollectorChain(): boolean {
        return (this.CollectorChain != null && this.CollectorChain.Count > 0);
    }

    public Write(obj: any, context: any): void {
        obj.discovery_subtask_status = {};
        obj = obj.discovery_subtask_status;

        if (this.HasSubtaskHandle)
            this.SubtaskHandle.Write(obj, context);

        if (this.HasTaskType)
            obj.task_type = this.TaskType;

        if (this.HasIpAddress)
            obj.ip_address = ValueEncoder.EncodeIpAddress(this.IpAddress);

        if (this.HasStartTime)
            obj.start_time = ValueEncoder.EncodeDateTime(this.StartTime);

        if (this.HasRunTime)
            obj.run_time = ValueEncoder.EncodeTimeSpan(this.RunTime);

        if (this.HasCollectorChain) {
            obj.collector_chain = [];
            ObjSerUtils.WriteObjSerCollection(obj.collector_chain, this.CollectorChain, context);
        }
    }

    public Read(obj: any, context: any): void {
        this.Clear();

        if (!obj.discovery_subtask_status) {
            throw new Error();
        }
        obj = obj.discovery_subtask_status;

        if (obj.discovery_subtask_handle !== undefined) {
            this.SubtaskHandle = new DiscoverySubtaskHandle();
            this.SubtaskHandle.Read(obj, context);
        }

        if (obj.task_type !== undefined)
            this.TaskType = obj.task_type;

        if (obj.ip_address !== undefined)
            this.IpAddress = ValueEncoder.DecodeIpAddress(obj.ip_address);

        if (obj.start_time !== undefined)
            this.StartTime = ValueEncoder.DecodeDateTime(obj.start_time);

        if (obj.run_time !== undefined)
            this.RunTime = ValueEncoder.DecodeTimeSpan(obj.run_time);

        if (obj.collector_chain !== undefined) {
            ObjSerUtils.ReadObjSerCollection(obj.collector_chain, this.CollectorChain,
                (value: any) => new CollectorChainEntry(), context);
        }
    }

}
